export default function Contact() {
  return (
    <div className="pt-32 pb-32 max-w-[720px] mx-auto px-4 md:px-8 min-h-[60vh]" data-testid="contact-page">
      <h1 className="font-display text-5xl md:text-6xl uppercase mb-8">Contact Us</h1>
      <p className="text-lg text-gray-700 leading-relaxed mb-4">
        Got a question, a complaint, or just want to talk trash? We read every email between sets.
        No bots, no hold music, no "your call is important to us" — just a real human who loves tennis
        way too much.
      </p>
      <p className="text-lg text-gray-700 leading-relaxed mb-8">
        Slide into our inbox. Worst case, you get a witty reply and free advice you didn't ask for.
      </p>
      <a
        href="mailto:gethard@rockhardtennis.com"
        className="inline-block bg-ink text-cream px-8 py-4 text-sm font-bold uppercase tracking-widest hover:bg-ink/85 transition-colors"
        data-testid="contact-email"
      >
        gethard@rockhardtennis.com
      </a>
    </div>
  );
}
